import type { LengthUOMProductDesc, LengthUOMProductId, WeightUOM, WeightUOMDescription } from './types';

export const WEIGHT_UOM_DESCRIPTIONS: Record<WeightUOM, WeightUOMDescription> = {
  KG: 'Kilogram',
  LB: 'Pound',
  OZ: 'OUNCE',
} as const;

export const DIM_UOM_DESCRIPTIONS: Record<LengthUOMProductId, LengthUOMProductDesc> = {
  C: 'cms',
  N: 'inches',
} as const;
